module.exports = __webpack_public_path__ + "media/images/redesign-images/backgrounds/camo-bg-8df11f7b4a4105e8e41db6557cc579a8.jpg";